import { useEffect } from 'react';

const PerformanceOptimizer = () => {
  useEffect(() => {
    // Preload critical resources
    const preloadResources = () => {
      const imagesToPreload = ['/logo.png', '/assets/hero-students.jpg'];
      imagesToPreload.forEach(src => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = src;
        link.as = 'image';
        document.head.appendChild(link);
      });
    };

    // Performance monitoring (no-op logs in production)
    const monitorPerformance = () => {
      if (!('performance' in window)) return;
      try {
        const observer = new PerformanceObserver(() => {});
        observer.observe({ entryTypes: ['navigation', 'largest-contentful-paint', 'first-input'] });
      } catch (e) {}
    };

    // DNS prefetch for external domains
    const optimizeNetwork = () => {
      const domains = [
        'https://admin.tinatacademy.com',
        'https://drive.google.com',
        'https://docs.google.com',
        'https://images.unsplash.com',
      ];
      domains.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      });
    };

    // Preconnect to critical domains
    const addResourceHints = () => {
      const preconnectDomains = [
        'https://admin.tinatacademy.com',
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com',
      ];
      preconnectDomains.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      });
    };

    preloadResources();
    monitorPerformance();
    optimizeNetwork();
    addResourceHints();
  }, []);

  return null;
};

export default PerformanceOptimizer;
